import { Controller } from "@hotwired/stimulus";
import initTiny from "../lib/tinymce-editor.js";

export default class extends Controller {
  static targets = [ "input" ]
  static values = { autofocus: { type: Boolean, default: false } }

  connect() {
    const id = this.inputTarget.id;
    tinymce.remove("#" + id);
    initTiny(this, "#" + id, null, true);

    if (this.autofocusValue) {
      this.focusWhenReady(id);
    }
  }

  disconnect() {
    tinymce.remove("#" + this.inputTarget.id);
  }

  focusWhenReady(id, attempt = 0) {
    if (!this.element.isConnected || attempt >= 20) return;

    const editor = tinymce.get(id);
    if (editor?.initialized) {
      editor.focus();
    } else if (editor) {
      editor.once("init", () => {
        if (this.element.isConnected) editor.focus();
      });
    } else {
      requestAnimationFrame(() => this.focusWhenReady(id, attempt + 1));
    }
  }
}
